module.exports = __webpack_public_path__ + "static/media/play-stone-placed.6fbdc93d.mp3";